/** Distinct palette for Word Connect words (up to 10 active per match). */
export const WORD_CONNECT_WORD_COLORS = [
  '#4A90D9',
  '#E74C3C',
  '#27AE60',
  '#9B59B6',
  '#F39C12',
  '#16A085',
  '#E67E22',
  '#2980B9',
  '#C0392B',
  '#8E44AD',
] as const;

export function wordConnectColorForIndex(index: number): string {
  return WORD_CONNECT_WORD_COLORS[((index % WORD_CONNECT_WORD_COLORS.length) + WORD_CONNECT_WORD_COLORS.length) % WORD_CONNECT_WORD_COLORS.length];
}

export function wordConnectTint(index: number, alpha = 0.14): string {
  const hex = wordConnectColorForIndex(index).replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
